//
// Copyright 2025 DXOS.org
//

import type { SearchResponse } from 'exa-js';

import Search1 from './exa-search-1748337321991';
import Search2 from './exa-search-1748337331526';
import Search3 from './exa-search-1748337344119';

export const SEARCH_RESULTS: SearchResponse<any>[] = [Search1, Search2, Search3];
